import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import VerordnungDto from '../Verordnung/VerordnungDto'
import VerordnungService from '../Verordnung/VerordnungService'
import DetailRow from '../../components/StaticDetailList/DetailRow'
import PercentageCell from '../../components/StaticDetailList/PercentageCell'
import GenericColumn from '@isceco/widget-library2/basic-elements/List/column/GenericColumn.js'
import DropdownMultiselectColumn from '@isceco/widget-library2/basic-elements/List/column/DropdownMultiselectColumn.js'
import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'
import DateCell from '@isceco/widget-library2/basic-elements/List/cell/DateCell.js'
import DateTimeCell from '@isceco/widget-library2/basic-elements/List/cell/DateTimeCell.js'
import LinkCell from '@isceco/widget-library2/basic-elements/List/cell/LinkCell.js'
import StaticRow from '@isceco/widget-library2/basic-elements/List/StaticRow.js'
import StyledCell from '../../components/StaticDetailList/StyledCell'

import '@isceco/widget-library2/basic-elements/List/StaticList.js'
import '../../components/StaticDetailList/StaticDetailList'

export default class VerordnungDetail extends WebComponent {

  constructor() {
    super()
    this.verordnungService = new VerordnungService()
    this.verordnung = new VerordnungDto()
    this.showAktivierungsDialog = false
    this.showStornierungsDialog = false
    this.datumStringMorgen = new Date(Date.now() + (24 * 60 * 60 * 1000)).toISOString().split('T')[0];
  }

  get translationFile() {
    return './views/VerordnungDetail/i18n.json'
  }

  get css() {
    return css`
      .twin-static-list-container {
        display: flex;
        gap: 20px;
        width: 100%;
      }

      .twin-static-list-item {
        width: 50%;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.verordnungService.read(getNavigationId()),
      this.verordnungService.listVerbrauchergruppe()
    ]).then(([json, verbGruppeList]) => {
      this.verordnung = new VerordnungDto(json)
      this.verbGruppeList = this._toVerbGruppeDropdown(verbGruppeList)
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.verordnung.srNummer}">
        <div style="display: flex; justify-content: center; align-items: center;">
          ${this._renderTitleButtons()}
        </div>
      </isceco-title>

      <div class="twin-static-list-container">
        <eko-static-detail-list .data="${this.getListData()}"
                                class="twin-static-list-item"
        ></eko-static-detail-list>

        <div class="twin-static-list-item">
          <isceco-title size="small"
                        style="margin-top: -20px;"
                        text="${this.i18n.translate('table.filter.verordnung.periode')}"
          ></isceco-title>
          <isceco-static-list id="verordnung-periode-list"
                              .i18n="${this.i18n}"
                              .columns="${this.getPeriodenColumns()}"
                              .data="${this.verordnung.perioden.map(periode => new StaticRow(periode))}"
          ></isceco-static-list>
          <isceco-title size="small"
                        text="${this.i18n.translate('table.filter.verordnung.verbrauchergruppe')}"
          ></isceco-title>
          <isceco-static-list id="verordnung-verbrauchergruppe-list"
                              .i18n="${this.i18n}"
                              .columns="${this.getKontingentierungssaetzeColumns(this.verbGruppeList)}"
                              .data="${this.verordnung.verbrauchergruppen.map(gruppe => new StaticRow(gruppe))}"
          ></isceco-static-list>
        </div>
      </div>
      ${this._renderAktivierungsDialog()}
      ${this._renderStornierungsDialog()}
    `
  }

  _renderTitleButtons() {
    if (this.verordnung.status === 'INAKTIV') {
      return html`
        <isceco-button id="edit-button"
                       size="small" icon="pencil" variant="primary"
                       text="${this.i18n.translate('base.button.edit')}"
                       @click="${_ => navigate({to: Navigation.ROUTES.verordnungEdit.url, id: this.verordnung.id})}"
        ></isceco-button>
        <isceco-button id="activate-button"
                       size="small" icon="check" variant="primary"
                       style="margin-left: 10px"
                       text="${this.i18n.translate('verordnung.activate.button')}"
                       @click="${_ => this._toggleAktivierungsDialog(true)}"
        ></isceco-button>
      `
    } else if (this.verordnung.status !== 'ABGESCHLOSSEN') {
      return html`
        <isceco-button id="cancel-button"
                       size="small" icon="times" variant="danger"
                       text="${this.i18n.translate('verordnung.cancel.button')}"
                       @click="${_ => this._toggleStornierungsDialog(true)}"
        ></isceco-button>
      `
    } else {
      return html``
    }
  }

  _renderAktivierungsDialog() {
    if (this.showAktivierungsDialog) {
      return html`
        <isceco-dialog id="activate-modal"
                       header="${this.i18n.translate('verordnung.activate.header')}"
                       description="${this.i18n.translate('verordnung.activate.description')}"
                       confirm-button="${this.i18n.translate('base.button.confirm')}"
                       cancel-button="${this.i18n.translate('base.button.cancel')}"
                       @submit="${e => this._handleAktivierungsDialog(e.detail)}"
        ></isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderStornierungsDialog() {
    if (this.showStornierungsDialog) {
      return html`
        <isceco-dialog id="cancel-modal"
                       header="${this.i18n.translate('verordnung.cancel.header')}"
                       description="${this.i18n.translate('verordnung.cancel.description')}"
                       confirm-button="${this.i18n.translate('base.button.confirm')}"
                       Cancel-button="${this.i18n.translate('base.button.cancel')}"
                       @submit="${e => this._handleStornierungsDialog(e.detail)}"
        >
          <isceco-date-input name="stornierungsdatum" required
                             label="${this.i18n.translate('verordnung.cancel.stornierungsdatum')} *"
                             min="${this.datumStringMorgen}"
                             max="${this.verordnung.geltungsdauerBis}"
                             open-on-click
          ></isceco-date-input>
        </isceco-dialog>
      `
    } else {
      return html``
    }
  }

  getListData() {
    const briefversandPflicht = this._translateHeader('briefversandPflicht.' + (this.verordnung.briefversandPflicht ? 'yes' : 'no'))
    const rows = [
      new DetailRow(this._translateHeader('srNummer'), this.verordnung.srNummer),
      new DetailRow(this._translateHeader('art'), this._translateEnum('art', this.verordnung.art)),
      new DetailRow(this._translateHeader('geltungsdauerVon'), this.verordnung.geltungsdauerVon, new DateCell()),
      new DetailRow(this._translateHeader('geltungsdauerBis'), this.verordnung.geltungsdauerBis, this._storniertCell(new DateCell(), _ => this.verordnung.storniertOn)),
      new DetailRow(this._translateHeader('stornierungsdatum'), this.verordnung.stornierungsdatum, new DateCell()),
      new DetailRow(this._translateHeader('status'), this._translateEnum('status', this.verordnung.status)),
      new DetailRow(this._translateHeader('link'), this.verordnung.link, new LinkCell({
        target: '_blank',
        url: _ => this.verordnung.link?.indexOf(':') >= 0 ? this.verordnung.link : `https://${this.verordnung.link}`
      })),
      new DetailRow(this._translateHeader('startPerioden'), this.verordnung.startPerioden, new DateCell()),
      new DetailRow(this._translateHeader('dauerPeriode'), this._translateEnum('dauerPeriode', this.verordnung.dauerPeriode)),
      new DetailRow(this._translateHeader('anzahl.' + this.verordnung.dauerPeriode.toLowerCase()), this.verordnung.anzahlZeit),
      new DetailRow(this._translateHeader('berechnungsart'), this._translateEnum('berechnungsart', this.verordnung.berechnungsartMain.toLowerCase())),
      new DetailRow(this._translateHeader('berechnungsart.' + this.verordnung.berechnungsartMain.toLowerCase()),
        this._translateEnum('berechnungsart.' + this.verordnung.berechnungsartMain.toLowerCase(), this.verordnung.berechnungsartSub?.toLowerCase())),
      new DetailRow(this._translateHeader('referenzjahr'), this.verordnung.referenzjahr?.join(', ')),
      new DetailRow(this._translateHeader('referenzart'), this.verordnung.referenzjahr.length > 2 ? this._translateEnum('referenzart', this.verordnung.referenzart) : undefined),
      new DetailRow(this._translateHeader('schwellwertAktiv'), this._translateBoolean(this.verordnung.schwellwertAktiv)),
      new DetailRow(this._translateHeader('schwellwert'), this.verordnung.schwellwert),
      new DetailRow(this._translateHeader('briefversandPflicht'), this.verordnung.briefversandPflicht === undefined ? undefined : briefversandPflicht),
      new DetailRow(this._translateHeader('aktiviertOn'), this.verordnung.aktiviertOn, new DateTimeCell()),
      new DetailRow(this._translateHeader('aktiviertBy'), this.verordnung.aktiviertBy),
      new DetailRow(this._translateHeader('storniertOn'), this.verordnung.storniertOn, new DateTimeCell()),
      new DetailRow(this._translateHeader('storniertBy'), this.verordnung.storniertBy),
    ]
    return rows.filter(row => row.dto.value !== undefined);
  }

  getPeriodenColumns() {
    return [
      new GenericColumn({
        key: 'start',
        text: 'table.filter.verordnung.periode.start',
        cell: this._storniertCell(new DateCell(), row => row.storniert)
      }),
      new GenericColumn({
        key: 'ende',
        text: 'table.filter.verordnung.periode.ende',
        cell: this._storniertCell(new DateCell(), row => row.storniert)
      })
    ]
  }

  getKontingentierungssaetzeColumns(verbGruppeList) {
    return [
      new DropdownMultiselectColumn({
        key: 'gruppe',
        text: 'table.filter.verordnung.verbrauchergruppe.gruppe',
        items: verbGruppeList
      }),
      new GenericColumn({
        key: 'prozentsatz',
        align: 'right',
        text: 'table.filter.verordnung.verbrauchergruppe.prozentsatz',
        cell: new PercentageCell()
      }),
      new StringColumn({
        key: 'ersparnis',
        text: 'table.filter.verordnung.verbrauchergruppe.ersparnis'
      })
    ]
  }

  _handleAktivierungsDialog = event => {
    if (!event.confirmed) {
      this._toggleAktivierungsDialog(false)
      return
    }

    this.verordnungService.activate(getNavigationId())
      .then(json => {
        window.showAlert(this.i18n.translate('verordnung.activate.alert.success', {srNummer: json.srNummer}), "", 'success')
        this._toggleAktivierungsDialog(false)
        this.reload()
      })
  }

  _handleStornierungsDialog = event => {
    if (!event.confirmed) {
      this._toggleStornierungsDialog(false)
      return
    }
    const stornierungsdatum = document.querySelector('#cancel-modal isceco-date-input[name=stornierungsdatum]')
    if (stornierungsdatum.validate()) {
      this.verordnungService.cancel(getNavigationId(), stornierungsdatum.getValue())
        .then(json => {
          window.showAlert(this.i18n.translate('verordnung.cancel.alert.success', {srNummer: json.srNummer}), "", 'success')
          this._toggleStornierungsDialog(false)
          this.reload()
        })
    }
  }

  _toggleAktivierungsDialog = show => {
    this.showAktivierungsDialog = show
    this.render()
  }

  _toggleStornierungsDialog = show => {
    this.showStornierungsDialog = show
    this.render()
  }

  _toVerbGruppeDropdown = list => list.map(item => ({value: item, name: this.i18n.translate(`verbrauchergruppe.${item.toLowerCase()}`)}))
  _translateHeader = header => this.i18n.translate(`table.header.verordnung.${header}`)
  _translateEnum = (msg, value) => value ? this.i18n.translate(`${msg}.${value.toLowerCase()}`) : undefined
  _translateBoolean = value => this.i18n.translate(value ? 'base.button.yes' : 'base.button.no')
  _storniertCell = (cell, isStorniert) => new StyledCell(cell, row => isStorniert(row) ? 'text-decoration: line-through; color: var(--isceco-color-grey-700);' : '')
}
customElements.define('eko-frontend-verordnung-detail', VerordnungDetail)
